module.exports = __webpack_public_path__ + "static/media/Mark Zuckerberg.2d6c1d2e.jpg";